import { render, staticRenderFns } from "./LoadingScene.vue?vue&type=template&id=7450fdda&scoped=true&"
import script from "./LoadingScene.vue?vue&type=script&lang=js&"
export * from "./LoadingScene.vue?vue&type=script&lang=js&"
import style0 from "./LoadingScene.vue?vue&type=style&index=0&id=7450fdda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7450fdda",
  null
  
)

export default component.exports